/**
 * Statistics views: used to display statistics on company, projects...
 * Path: `@/views/statistics`
 */

import multiguard from "vue-router-multiguard"
import { requireAuth, requireCompany } from "@/utils/middleware"

const DashboardReports = () => import("@/views/statistics/DashboardReports.vue")

export default [
  {
    path: "/dashboard",
    component: DashboardReports,
    name: "DashboardReports",
    beforeEnter: multiguard([requireAuth, requireCompany]),
    meta: {
      layout: "default"
    }
  }
]
